import { authStore } from "../../stores/General";
import { getClient } from "./client";

export async function logout(options = {}) {
  const client = await getClient();
  authStore.isAuthenticated.set(false);
  localStorage.removeItem("token");
  return client.logout(options);
}